import cloneDeep from 'lodash/cloneDeep';

import type { SmsFilters } from '@webapp/account/src/resources/smsing/filters';
import { initialFilters } from '@webapp/account/src/resources/smsing/filters';
import type { SmsDetail } from '@webapp/account/src/resources/smsing/sms-detail';
import type { Sms, SmsGroup } from '@webapp/account/src/resources/smsing/smsing';
import { initialSms } from '@webapp/account/src/resources/smsing/smsing';
import type { Stat } from '@webapp/account/src/resources/smsing/stat';
import { initialStat } from '@webapp/account/src/resources/smsing/stat';

export interface SmsingState {
    item: Sms;
    items: Array<Sms>;
    stat: Stat;
    smsDetails: Array<SmsDetail>;
    smsDetailsPage: number;
    smsDetailsTotalCount: number;
    filters: SmsFilters;
    sendDates: Array<string>;
    rawSms: Array<string>;
    csvSms: Array<string>;
    smsGroups: Array<SmsGroup>;
    fetch: boolean;
    csvDownloadFetch: boolean;
    fileUpload: boolean;
    smsListLoaded: boolean;
}

export const initialState: Readonly<SmsingState> = {
    item: {
        ...cloneDeep(initialSms),
        id: 1,
    },
    items: [],
    smsDetails: [],
    smsDetailsPage: 1,
    smsDetailsTotalCount: 0,
    filters: cloneDeep(initialFilters),
    sendDates: [],
    stat: cloneDeep(initialStat),
    rawSms: [],
    csvSms: [],
    smsGroups: [],
    fetch: true,
    csvDownloadFetch: false,
    fileUpload: false,
    smsListLoaded: false,
};
